import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import {
  LiveBetsContainer,
  TranslationKeys,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { LiveBetItem } from '../liveBetsItems/myBets';
import { OtherBetItem } from '../liveBetsItems/otherBets';
import { globalTranslationKeys } from '../../../enums';

export const LiveBetsWrapper = observer(() => {
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  const myLiveBetItem = useCallback((data) => {
    return <LiveBetItem key={data.id} data={data} />;
  }, []);

  const renderOtherLiveBetItem = useCallback(
    (data) => <OtherBetItem key={data.id} data={data} />,
    []
  );

  return (
    <LiveBetsContainer
      renderMyLiveBetItem={myLiveBetItem}
      renderOtherLiveBetItem={renderOtherLiveBetItem}
      headerNames={[
        { name: `${t(TranslationKeys.PlayerId)}` },
        { name: `${t(globalTranslationKeys.Bet)} (${currencySymbolOrCode})` },
        { name: `${t(globalTranslationKeys.Odd)}` },
        { name: `${t(globalTranslationKeys.Win)} (${currencySymbolOrCode})` },
      ]}
    />
  );
});
